export default "__VITE_ASSET__C_Qi$T0___"